import React, { useEffect, useState } from 'react';
import { SimpleTreeView, TreeItem } from '@mui/x-tree-view';
import {
    Checkbox,
    FormControlLabel,
    Typography,
} from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import LeaseApiService from '../../services/apiService';
import './UserPropertyAccess.css';
import { ClipLoader } from 'react-spinners';
import { FaSave, FaChevronLeft } from "react-icons/fa";
import { useSelector } from 'react-redux';
import { getName } from '../../../Redux/selecters';
import { toast } from 'react-toastify';

const UserPropertyAccessEdit = () => {
    const [treeData, setTreeData] = useState([]);
    const location = useLocation();
    const leaseData = location.state;
    const apiService = new LeaseApiService();
    const [loading, setloader] = useState(false);
    const userName = useSelector(getName);
    let navigate = useNavigate()

    useEffect(() => {
        getItems();
    }, []);

    const getItems = async () => {
        try {
            const params = new URLSearchParams();
            params.append('UserName', leaseData?.user_Name);
            params.append('UserNo', leaseData?.user_No);
            params.append('CompanyNo', leaseData?.company);

            const res = await apiService.getApiParamater('GET_ACCESS_LIST_DETAIL', `?${params.toString()}`);
            const apiData = res?.data?.result || [];

            // Convert API response to tree structure
            const companyGroups = {};

            apiData.forEach((item) => {
                const company = item.companyName;
                if (!companyGroups[company]) {
                    companyGroups[company] = [];
                }
                companyGroups[company].push({ ...item });
            });
            
            const formattedTree = Object.entries(companyGroups).map(([companyName, properties]) => ({
                key: companyName,
                title: companyName,
                children: properties.map((p) => ({
                    key: p?.propertyId,
                    title: p?.propertyName,
                    hasAccess: p?.hasAccess,
                })),
            }));

            setTreeData(formattedTree);
        } catch (error) {
            console.error('Error fetching items:', error);
        }
    };
    const handleCheckboxChange = (companyKey, propertyKey, isParent = false) => {
        const updatedTree = treeData.map((company) => {
            if (company.key !== companyKey) return company;

            // If parent checkbox toggled
            if (isParent) {
                const parentChecked = !company.children?.every(child => child.hasAccess);
                return {
                    ...company,
                    children: company.children?.map(child => ({
                        ...child,
                        hasAccess: parentChecked,
                    })),
                };
            }

            // If child checkbox toggled
            return {
                ...company,
                children: company.children.map((child) =>
                    child.key === propertyKey
                        ? { ...child, hasAccess: !child.hasAccess }
                        : child
                ),
            };
        });

        setTreeData(updatedTree);
    };

    const renderTree = (nodes) => {
        const allChildrenSelected = nodes.children?.every(child => child.hasAccess);
        const someChildrenSelected = nodes.children?.some(child => child.hasAccess);
        
        return (
            <TreeItem
                sx={{ padding: 0 }}
                key={nodes.key}
                itemId={nodes.key}
                label={
                    nodes.children ? (
                        <FormControlLabel
                            control={
                                <Checkbox
                                    size="small"
                                    checked={allChildrenSelected}
                                    indeterminate={!allChildrenSelected && someChildrenSelected}
                                    onChange={() => handleCheckboxChange(nodes.key, null, true)}
                                />
                            }
                            label={
                                <Typography variant="body2" fontWeight="bold">
                                    {nodes.title}
                                </Typography>
                            }
                        />
                    ) : (
                        <FormControlLabel
                            control={
                                <Checkbox
                                    size="small"
                                    checked={nodes.hasAccess}
                                    onChange={() => handleCheckboxChange(nodes.companyKey, nodes.key)}
                                />
                            }
                            label={<Typography variant="body2">{nodes.title}</Typography>}
                        />
                    )
                }
            >
                {Array.isArray(nodes.children)
                    ? nodes.children.map((child) =>
                        renderTree({ ...child, companyKey: nodes.key })
                    )
                    : null}
            </TreeItem>
        );
    };

    const handleSave = async () => {
        setloader(true);
        const selectedProperties = treeData
            .flatMap((company) =>
                company.children
                    .filter((property) => property.hasAccess)
                    .map((property) => property.key)
            );

        const requestBody = {
            property_No: selectedProperties,
            assigned_UserNo: leaseData?.user_No,
            assigned_UserName: leaseData?.user_Name,
            assigned_By: userName
        };

        try {
            const res = await apiService.post('CREATE_PROPERTY_ACCESS', requestBody);
            if (res?.data?.statusCode === 201 || res?.data?.statusCode === 200) {
                setloader(false);
                navigate('/Lease/Management/Property/Access')
            } else {
                toast.warning(`${res?.data?.message}`);
                setloader(false);
            }
        } catch (error) {
            console.error('Save error:', error);
            toast.error('Failed to save access.');
        }
    };
    const handleBackClick = () => {
        window.history.back();
    };
    return (
        <div className='p-3'>
            <div className='border-box2 d-flex justify-content-between p-3' style={{ borderRadius: "8px" }}>
                <div className='center'><h6>User Property Access</h6></div>
                <div className='end d-flex gap-1'>
                    {loading === true ?
                        <div className='mainbtn flex-end gap-2'>
                            <ClipLoader color="#ffffff" className='mt-1' size={25} />
                        </div>
                        :
                        <div className='mainbtn flex-end gap-2 ' onClick={handleSave}>
                            <FaSave color='#fff' className='center mt-1 mx-2' />
                            <div className='center'>Save</div>
                        </div>
                    }
                    <div className='mainbtnSecondary flex-end gap-2' onClick={handleBackClick}>
                        <FaChevronLeft color='#fff' className='center mt-1 mx-2' />
                        <div className='center'>Back</div>
                    </div>
                </div>
            </div>
            <div className="row mt-4">
                <div className="col-md-4 col-12 mb-4">
                    <div className="user-form">
                        <label className="form-label">User ID*</label>
                        <input className="input" value={leaseData?.user_Id} disabled />
                        <label className="form-label">Full Name*</label>
                        <input className="input" disabled value={leaseData?.user_Fullname} />
                        <label className="form-label">Department*</label>
                        <input className="input" disabled value={leaseData?.department} />
                        <label className="form-label">Role*</label>
                        <input className="input" disabled value={leaseData?.role} />
                        <label className="form-label">Email ID</label>
                        <input className="input" disabled value={leaseData?.emailId} />
                        <label className="form-label">Phone No</label>
                        <input className="input" disabled value={leaseData?.mobileNo} />
                    </div>
                </div>
                <div className="col-md-8 col-12">
                    <div className="user-tree">
                        <div className="tree-header">User Privileges</div>
                        <SimpleTreeView sx={{ padding: 0 }}>
                            {treeData.map((node) => renderTree(node))}
                        </SimpleTreeView>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UserPropertyAccessEdit;